import React, { useState } from "react";
import { Card, Button, Icon, Form, Confirm, Label } from "semantic-ui-react";
import moment from "moment";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./AnswersForm.form";
import { Answer } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ReactionButton } from "../../../Student/Forum/ReactionButton";
import "./AnswerList.scss";

const answerController = new Answer();

export function AnswerList(props) {
  const { post, answers, getStatusLabel, onReload } = props;
  const { accessToken } = useAuth();
  const [action, setAction] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        formValue.postId = post.id;
        const response = await answerController.createAnswer(
          accessToken,
          formValue
        );
        formik.resetForm();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const onAnswerAction = async () => {
    try {
      if (action === "approve") {
        await answerController.updateAnswer(accessToken, answer.id, {
          status: 1,
        });
      } else if (action === "reject") {
        await answerController.updateAnswer(accessToken, answer.id, {
          status: 2,
        });
      } else if (action === "correct") {
        await answerController.updateAnswer(accessToken, answer.id, {
          isCorrect: true,
        });
      } else if (action === "incorrect") {
        await answerController.updateAnswer(accessToken, answer.id, {
          isCorrect: false,
        });
      }
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <h2 className="post-page__answer-title">Respuestas ({answers?.length})</h2>

      {answers?.map((answer) => (
        <Card className="answer-card" fluid key={answer.id}>
          <Card.Content>
            <Card.Meta className="answer-card__header">
              <div className="answer-card__header-title">
                Por{" "}
                {`${answer.User.firstname} ${answer.User.lastname} ${answer.User.secondLastname}`}{" "}
                • {moment.utc(answer?.createdAt).local().format("DD/MM/YYYY hh:mm a")}
              </div>
              <div className="answer-card__header-labels">
                {answer.isCorrect !== null && (
                  <Label
                    className="answer-card__resolve-label"
                    size="large"
                    color={answer.isCorrect ? "green" : "red"}
                    horizontal
                    content={answer.isCorrect ? "Correcta" : "Incorrecta"}
                  />
                )}
                {post?.status !== 2 && getStatusLabel(answer.status)}
              </div>
            </Card.Meta>
            <Card.Description>{answer.content}</Card.Description>
            <div className="answer-card__reactions">
              <ReactionButton targetType="answer" target={answer} />
            </div>
          </Card.Content>
          {answer.status === 0 && post?.status !== 2 && (
            <Card.Content extra>
              <div className="ui two buttons">
                <Button
                  basic
                  color="green"
                  onClick={() => {
                    setAction("approve");
                    setConfirmMessage(
                      "¿Estás seguro que deseas aprobar la respuesta?"
                    );
                    setAnswer(answer);
                    onOpenCloseConfirm();
                    // onAnswerAction("approve", answer);
                  }}
                >
                  <Icon name="check" /> Aprobar
                </Button>
                <Button
                  basic
                  color="red"
                  onClick={() => {
                    setAction("reject");
                    setConfirmMessage(
                      "¿Estás seguro que deseas rechazar la respuesta?"
                    );
                    setAnswer(answer);
                    onOpenCloseConfirm();
                    // onAnswerAction("reject", answer);
                  }}
                >
                  <Icon name="x" /> Rechazar
                </Button>
              </div>
            </Card.Content>
          )}
          {answer?.isCorrect == null && post?.status !== 2 && (
            <Button.Group className="answer-card__footer two">
              <Button
                color="blue"
                onClick={() => {
                  setAction("correct");
                  setConfirmMessage(
                    "¿Estás seguro que deseas marcar como correcta la respuesta?"
                  );
                  setAnswer(answer);
                  onOpenCloseConfirm();
                  // onAnswerAction("resolve", answer);
                }}
              >
                <Icon name="check circle" /> Correcta
              </Button>
              <Button
                color="red"
                onClick={() => {
                  setAction("incorrect");
                  setConfirmMessage(
                    "¿Estás seguro que deseas marcar como incorrecta la respuesta?"
                  );
                  setAnswer(answer);
                  onOpenCloseConfirm();
                  // onAnswerAction("resolve", answer);
                }}
              >
                <Icon name="times circle" /> Incorrecta
              </Button>
            </Button.Group>
          )}
        </Card>
      ))}

      {post?.status !== 2 && !post?.solved && (
        <Card className="answer-reply-card" fluid>
          <Card.Content>
            <Form className="answer-reply-card__form" onSubmit={formik.handleSubmit} reply>
              <Form.TextArea
                name="content"
                label="Respuesta"
                onChange={formik.handleChange}
                value={formik.values.content}
                error={formik.errors.content}
              />
              <Form.Button
                type="submit"
                content="Añadir respuesta"
                labelPosition="left"
                icon="edit"
                primary
                loading={formik.isSubmitting}
              />
            </Form>
          </Card.Content>
        </Card>
      )}

      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onAnswerAction}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
